import type { ResourceDependencies } from '@atlassian/react-resource-router/src/common/types';
import { consumeDependency } from '@atlassian/jira-router-resources-utils/src/utils/consume-dependency/index.tsx';

export const getDependencyData = <T,>(
	dependencies: ResourceDependencies,
	key: string,
): T | Promise<T> => {
	if (dependencies[key]?.loading || dependencies[key]?.error) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return consumeDependency(dependencies, key) as Promise<T>;
	}
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return dependencies[key]?.data as T;
};
